module.exports = __webpack_public_path__ + "static/img/4.4604a7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newFour/4.png
// module id = Fvl7
// module chunks = 0